import {Modal} from 'antd';
import {useEffect, useState} from 'react';

import {Locale} from '../../../provider/locale/locale';
import {postCompanySelectorCompanySchema} from '../../../service/feature-companies/feature-companies-api-type';
import {CompaniesSelectorFeatureEnum} from '../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../service/feature-companies/feature-companies-hook';
import {PostSelectorCompanyType} from '../../../service/feature-companies/feature-companies-type';
import {useCreatePromotion} from '../../../service/promotions/promotions-hook';
import {CommonPromotionStatusEnum, PromotionFormType} from '../../../service/promotions/promotions-type';

import {PromotionForm} from './promotion-form';
import {preparePromotionRequestData, PROMOTION_SELECT_COMPANIES_STEP_WIDTH} from './promotion-form-helper';

type PropsType = {
    setIsOpen: (isOpen: boolean) => void;
    onCreateSuccess?: VoidFunction;
};

export function CreatePromotionFormModal({setIsOpen, onCreateSuccess}: PropsType): JSX.Element {
    const [modalWidth, setModalWidth] = useState<number>(PROMOTION_SELECT_COMPANIES_STEP_WIDTH);

    const companiesSelector = useCompaniesSelector<PostSelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.Posts,
        companySchema: postCompanySelectorCompanySchema,
        resourceId: null,
    });

    const {mutateAsync: createPromotion} = useCreatePromotion();
    const {initializeSelector, selectorId} = companiesSelector;

    useEffect(() => {
        initializeSelector();
    }, [initializeSelector]);

    async function handleSubmit(values: PromotionFormType, status: CommonPromotionStatusEnum): Promise<void> {
        await createPromotion(preparePromotionRequestData(values, selectorId, status));
        onCreateSuccess?.();
    }

    return (
        <Modal
            centered
            destroyOnClose
            footer={null}
            onCancel={() => setIsOpen(false)}
            open
            title={<Locale stringKey="PROMOTIONS__CREATE__TITLE" />}
            width={modalWidth}
        >
            <PromotionForm
                closeModal={() => setIsOpen(false)}
                companiesSelector={companiesSelector}
                mode="create"
                onChangeStep={setModalWidth}
                onSubmit={handleSubmit}
            />
        </Modal>
    );
}
